import { ref } from "vue";
export const CLIENT_SK =
  'E44r2Mb5INCabAd9Pa2f9ch2nbKj9SGi+uADqLahLKzibkOtspm7owao+ULDW4wEvwj+pX+DEBsk3wpOEC7Q0gViPZZxORozd0RdDK8RfgW4OIKILY/cKs6dt5ch6CHgJ4CuLGbKGQy1ChOVVmHS1d35HhiYk5yKOSPpwF7s57I=';
export const CLIENT_ID = 'O8dwerWROermmdf'; // 客户端ID
export const CLIENT_ID_MOBILE = 'd3mobile'; // 移动端端ID

export const CLIENT_VER = '0.0.1'; // 客户端把岸本
// 加密公钥 todo 后续修改判租户后动态获取
export const RSA_PUBLIC_KEY =
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCJvDI9R8kq8l8ghZPRna3IS0B3SA7aJlcg44tp7DiTx5AYqAFuBUPfnTldYpkux/zFPnZ115b3eOC10aG+/PcGBOMM+ul5LNNh3Jz82GsfDmAyeQzG8XFLIsvt/WzoKHkAAmpTWX1NZOmxnT5Te8ML+DskYSy0GieJNoOulOlJYwIDAQAB';
// 解密私钥
export const RSA_PRIVATE_KEY = 'MIICdQIBADANBgkqhkiG9w0BAQEFAASCAl8wggJbAgEAAoGBALeuSxwhYFrxvH08jUZ7YGFwlSnLnK+GcaTyI/BBj53DMDKEsO0qVQoLEh1PUYLluHlmQpMqcDKFT4R/HnHAX58sVwe0uK8wgrZBiprkleJSOoKQaWB0KnCB2Ld1rhOXvpYst75pzbpF7tQ8dVwe60/mNMN9rkyp06b8rhJbgBFNAgMBAAECgYAc7ZjLtd/4gsDmUm6Hjq/HuNTtL7GeHUTxrucFFDY7qP2Cv04kE/ovqj2wmwjh3i8XA4lxpwnjkwZKfkC7ton4gUdelgU4sQ+IfPw01q9m5wO2QLALVe9lUgOaj6cNJ44JteYMUfHXJ1xYUD2FQumAyPpkvKNBJypZ2bs/+MStYQJBAL8JxSwoQksynaP17wk9pcGASOAXlwQccEPxRCuMI45+CZqIYTZG526AZvQBedL96WVJD96e1rbFLmclllrpyR0CQQD2JA3Bmj3v/B0EfooUD+9R2Zs9ZtTPajkan9GO0hDPZTNlFmUThv6pqH9y5N9FuFrr1xwzYVCDDENhaHJg4SHxAkAz6aLD8hi5uIJv+LfBKhht8b9b7e0it9umCtz8fHN5GDTh4meQSUpAk/HmIrSJKmiPFoCSfVVZi1Glw+gMwnTdAkAp6ROqjm/TaBMsy7sJFXmDb1D+kH7V3llgziupbN1N4wZwRPLq80ZzbuxcjNnzjiN1GsiDeyNxXOowMM+g7VSRAkBrGraKhAvUlVLxvN8IapSrxlDonRL1FDei2nGCg6z9lKnnh8MjJiE7OdsDWBBUNNXIb66R89gs8k8Q6hZ+a6Kk';

export const prefix = 'tdesign-starter';
export const TOKEN_NAME = 'tdesign-starter';
export const TOKEN_USER = 'tdesign-user';
export const SLT_NAME = 'slt';
export const baseUrl = '';
export const storage = 'localStorage';

export const AES_KEY = 'Y23B56789AHAEQ0Z';
export const AES_IV = 'DYgjCEIMVrj2W9xN';
export const APP_NAME = 'smart';

//全局的变量
let gBrowser:string;//浏览器标志
export function getBrowser(){
  return gBrowser;
}
export function setBrowser(browser:string){
  gBrowser = browser
}

//不使用ref()外部监控不到
let gH = ref(0);//浏览器高度，一般用于dialog高度
let gW:number;
let gCH:number;//content区域的高度
let tmp:any;//临时借用，刷新页面可以丢失

export function setTmp(t:any){
 tmp = t;
}

export function getTmp(){
  return tmp;
}

export function getCH(){
  return gCH;
}

export function setCH(height:number){
  gCH = height;
}

let navHeight = 0;
export function getNavHeight(){
  return navHeight;
}

export function setNavHeight(height:number){
  if(height){
    navHeight = height;
  }
}


let tabsHeight = 0;
export function getTabsHeight(){
  return tabsHeight;
}



export function setTabsHeight(height:number){
  if(height){
    tabsHeight = height;
  }
}


let breadHeight = 0;
export function getBreadHeight(){
  return breadHeight;
}

export function setBreadHeight(height:number){
  breadHeight = height
}

let footerHeight = 0;
export function getFooterHeight(){
  return footerHeight;
}

export function setFooterHeight(height:number){
  footerHeight = height
}

/**该值必须是ref类型的，否则调用点使用watch监控不到 */
export function getBodyHeight(){
  return gH;
}

export function getW(){
  return gW;
}

export function setBodyHeight(height:number, width:number){
  gH.value = height;
  gW = width;
}


let tabs:number = 0;//菜单的高度
export function setTabsH(height:number){
  if(height){
    tabs = height;
  }
}

export function getMenuH(){
  return tabs;
}

